import React from "react";
import { useCheckout } from "../../hooks/useCheckout";
import ErrorView from "../errorView/errorView";
import { CheckoutErrorSection } from "./checkoutErrorSection";
import { CheckoutSuccessSection } from "./checkoutSuccessSection";


export const ProcessOrder = () => {
  const { checkout, error } = useCheckout();

  // Gestione errori - priorità agli errori di React Query
  const hasError = error || checkout.error;
  const errorMessage = error?.message || checkout.error?.message;
  const errorStatus = checkout.error?.status || "error";

  // Determina se è un errore di checkout o un errore generico
  const isCheckoutError = hasError && (
    errorMessage?.includes('420') ||
    errorMessage?.includes('401') ||
    errorMessage?.includes('403') ||
    errorMessage?.includes('500') ||
    errorMessage?.includes('Network') ||
    errorMessage?.includes('ERR_NETWORK') ||
    errorMessage?.includes('timeout') ||
    errorMessage?.includes('ERR_TIMEOUT') ||
    errorMessage?.includes('credito') ||
    errorMessage?.includes('server') ||
    checkout.error // Errori salvati in Zustand sono sempre errori di checkout
  );

  // Rendering condizionale basato sul tipo di errore
  if (hasError) {
    if (isCheckoutError) {
      // Usa il nuovo componente per errori di checkout
      return <CheckoutErrorSection error={hasError} checkout={checkout} />;
    } else {
      // Usa ErrorView per errori generici (auth, etc.)
      return <ErrorView error={{ msg: errorMessage, status: errorStatus }} />;
    }
  }

  // Nessun errore - mostra successo
  return <CheckoutSuccessSection checkout={checkout} />;
};
